// sagas/eventVendorSaga.js

import { call, all, takeEvery } from 'redux-saga/effects';
import {
  listEventVendorsRequest,
  searchEventVendorsRequest,
  filterEventVendorsRequest,
  exportEventVendorsRequest,
  getEventVendorInfoRequest,
  updateEventVendorInfoRequest,
  addEventVendorRequest
} from '../../api/eventVendor'; // API imports
import {
  listEventVendors,
  searchEventVendors,
  filterEventVendors,
  exportEventVendors,
  getEventVendorInfo,
  updateEventVendorInfo,
  addEventVendor
} from '../actions/eventVendor'; // Promise actions

import { resolvePromiseAction, rejectPromiseAction } from '@adobe/redux-saga-promise';
import { translateErrorResponse } from '../../utils/utils';

// Saga to handle listing eventVendors
export function* handleListEventVendor(action) {
  try {
    const response = yield call(listEventVendorsRequest, action.payload);
    yield call(resolvePromiseAction, action, response?.data?.data ?? {}); // Resolve the promise action
  } catch (err) {
    const errorMessage = translateErrorResponse(err).message;
    yield call(rejectPromiseAction, action, errorMessage); // Reject the promise action
  }
}

// Saga to handle searching eventVendors
export function* handleSearchEventVendor(action) {
  try {
    const response = yield call(searchEventVendorsRequest, action.payload);
    yield call(resolvePromiseAction, action, response?.data ?? {}); // Resolve the promise action
  } catch (err) {
    const errorMessage = translateErrorResponse(err).message;
    yield call(rejectPromiseAction, action, errorMessage); // Reject the promise action
  }
}

// Saga to handle filtering eventVendors
export function* handleFilterEventVendor(action) {
  try {
    const response = yield call(filterEventVendorsRequest, action.payload);
    yield call(resolvePromiseAction, action, response?.data ?? {}); // Resolve the promise action
  } catch (err) {
    const errorMessage = translateErrorResponse(err).message;
    yield call(rejectPromiseAction, action, errorMessage); // Reject the promise action
  }
}

// Saga to handle exporting eventVendors
export function* handleExportEventVendor(action) {
  try {
    const response = yield call(exportEventVendorsRequest, action.payload);
    yield call(resolvePromiseAction, action, response?.data ?? {}); // Resolve the promise action
  } catch (err) {
    const errorMessage = translateErrorResponse(err).message;
    yield call(rejectPromiseAction, action, errorMessage); // Reject the promise action
  }
}

// Saga to handle viewing eventVendor details
export function* handleGetEventVendorInfo(action) {
  try {
    const response = yield call(getEventVendorInfoRequest, action.payload);
    yield call(resolvePromiseAction, action, response?.data ?? {}); // Resolve the promise action
  } catch (err) {
    const errorMessage = translateErrorResponse(err).message;
    yield call(rejectPromiseAction, action, errorMessage); // Reject the promise action
  }
}

// Saga to handle updating eventVendor info
export function* handleUpdateEventVendorInfo(action) {
  try {
    const response = yield call(updateEventVendorInfoRequest, action.payload);
    yield call(resolvePromiseAction, action, response?.data ?? {}); // Resolve the promise action
  } catch (err) {
    const errorMessage = translateErrorResponse(err).message;
    yield call(rejectPromiseAction, action, errorMessage); // Reject the promise action
  }
}

// Saga to handle adding a eventVendor
export function* handleAddEventVendor(action) {
  try {
    const response = yield call(addEventVendorRequest, action.payload);
    yield call(resolvePromiseAction, action, response?.data ?? {}); // Resolve the promise action
  } catch (err) {
    const errorMessage = translateErrorResponse(err).message;
    yield call(rejectPromiseAction, action, errorMessage); // Reject the promise action
  }
}

// Root saga to watch for eventVendor actions
export default function* eventVendorSaga() {
  yield all([
    takeEvery(listEventVendors.trigger, handleListEventVendor), // Watch for listEventVendors action
    takeEvery(searchEventVendors.trigger, handleSearchEventVendor), // Watch for searchEventVendors action
    takeEvery(filterEventVendors.trigger, handleFilterEventVendor), // Watch for filterEventVendors action
    takeEvery(exportEventVendors.trigger, handleExportEventVendor), // Watch for exportEventVendors action
    takeEvery(getEventVendorInfo.trigger, handleGetEventVendorInfo), // Watch for getEventVendorInfo action
    takeEvery(updateEventVendorInfo.trigger, handleUpdateEventVendorInfo), // Watch for updateEventVendorInfo action
    takeEvery(addEventVendor.trigger, handleAddEventVendor), // Watch for addEventVendor action
  ]);
}
